// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1__cdb485c50d5201b2fa5b","cls2":"Comments-cls2___a94bb8efeca8f9fe033 Comments-cls1__cdb485c50d5201b2fa5b"};